/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "erc20",
                type: "address",
            },
            {
                internalType: "address",
                name: "_mailbox",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint32",
                name: "domain",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "gas",
                type: "uint256",
            },
        ],
        name: "GasSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_hook",
                type: "address",
            },
        ],
        name: "HookSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_ism",
                type: "address",
            },
        ],
        name: "IsmSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint32",
                name: "origin",
                type: "uint32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "recipient",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "ReceivedTransferRemote",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint32",
                name: "destination",
                type: "uint32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "recipient",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "SentTransferRemote",
        type: "event",
    },
    {
        inputs: [],
        name: "PACKAGE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        name: "destinationGas",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "domains",
        outputs: [
            {
                internalType: "uint32[]",
                name: "",
                type: "uint32[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_domain",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_router",
                type: "bytes32",
            },
        ],
        name: "enrollRemoteRouter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32[]",
                name: "_domains",
                type: "uint32[]",
            },
            {
                internalType: "bytes32[]",
                name: "_addresses",
                type: "bytes32[]",
            },
        ],
        name: "enrollRemoteRouters",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "fastTransferId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_destination",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_recipient",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "_amountOrId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_fastFee",
                type: "uint256",
            },
        ],
        name: "fastTransferRemote",
        outputs: [
            {
                internalType: "bytes32",
                name: "messageId",
                type: "bytes32",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_fastFee",
                type: "uint256",
            },
            {
                internalType: "uint32",
                name: "_origin",
                type: "uint32",
            },
            {
                internalType: "uint256",
                name: "_fastTransferId",
                type: "uint256",
            },
        ],
        name: "fillFastTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_origin",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_sender",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_message",
                type: "bytes",
            },
        ],
        name: "handle",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "hook",
        outputs: [
            {
                internalType: "contract IPostDispatchHook",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_hook",
                type: "address",
            },
            {
                internalType: "address",
                name: "_interchainSecurityModule",
                type: "address",
            },
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "interchainSecurityModule",
        outputs: [
            {
                internalType: "contract IInterchainSecurityModule",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "localDomain",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mailbox",
        outputs: [
            {
                internalType: "contract IMailbox",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_destinationDomain",
                type: "uint32",
            },
        ],
        name: "quoteGasPayment",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_domain",
                type: "uint32",
            },
        ],
        name: "routers",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "domain",
                type: "uint32",
            },
            {
                internalType: "uint256",
                name: "gas",
                type: "uint256",
            },
        ],
        name: "setDestinationGas",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "domain",
                        type: "uint32",
                    },
                    {
                        internalType: "uint256",
                        name: "gas",
                        type: "uint256",
                    },
                ],
                internalType: "struct GasRouter.GasRouterConfig[]",
                name: "gasConfigs",
                type: "tuple[]",
            },
        ],
        name: "setDestinationGas",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_hook",
                type: "address",
            },
        ],
        name: "setHook",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_module",
                type: "address",
            },
        ],
        name: "setInterchainSecurityModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_destination",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_recipient",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "_amountOrId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_hookMetadata",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "_hook",
                type: "address",
            },
        ],
        name: "transferRemote",
        outputs: [
            {
                internalType: "bytes32",
                name: "messageId",
                type: "bytes32",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_destination",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_recipient",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "_amountOrId",
                type: "uint256",
            },
        ],
        name: "transferRemote",
        outputs: [
            {
                internalType: "bytes32",
                name: "messageId",
                type: "bytes32",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_domain",
                type: "uint32",
            },
        ],
        name: "unenrollRemoteRouter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32[]",
                name: "_domains",
                type: "uint32[]",
            },
        ],
        name: "unenrollRemoteRouters",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "wrappedToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class FastHypERC20Collateral__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(erc20, _mailbox, overrides) {
        return super.deploy(erc20, _mailbox, overrides || {});
    }
    getDeployTransaction(erc20, _mailbox, overrides) {
        return super.getDeployTransaction(erc20, _mailbox, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
//# sourceMappingURL=FastHypERC20Collateral__factory.js.map